import { render } from "./NykForm.vue?vue&type=template&id=72add890"
import script from "./NykForm.vue?vue&type=script&lang=js"
export * from "./NykForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__